import { sendingMessageStatus } from '@/config/constants';
import { FetchChatMessagesMutation } from '@/graphql';

type Messages = NonNullable<
	NonNullable<FetchChatMessagesMutation['getChat']>['messages']
>['items'];

export function deduplicateMessages(messages: Messages): Messages {
	return messages.reduce<Messages>((acc, message) => {
		if (message.createdAt === sendingMessageStatus) {
			const receivedMessage = messages.find(
				(m) =>
					m.id === message.id && m.createdAt !== sendingMessageStatus,
			);
			if (receivedMessage) {
				return [...acc, receivedMessage];
			} else {
				return [...acc, message];
			}
		}
		if (acc.find((m) => m.id === message.id)) {
			return acc;
		}
		return [...acc, message];
	}, []);
}
